import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ConfigurationService } from '@ciam/library';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryParamService } from '../services/query-param/query-param.service';
import { HeadFootService, LocaleService } from '@ciam/library';
import { HostContextService } from '../../services/host-context/host-context.service';

@Injectable({
  providedIn: 'root'
})

export class UserLoggedInGuard implements CanActivate  {

  constructor(
    private configService: ConfigurationService,
    private localService: LocaleService,
    private sharedService: SharedService,
    private queryParamService: QueryParamService,
    private hostContext: HostContextService,
    private headFootService: HeadFootService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if(this.canBypassGuard(route)) {
      return of(true);
    }
    else {
      return this.headFootService.isUser$().pipe(
        map((response) => {
          if(response) {
            return true;
          }
          else {
            this.sharedService.openURL(this.getRedirectUrl());
            return false;
          }
        })
      );
    }
  }

  /** This will check for local/development.mock modes that can bypass route guards */
  canBypassGuard(snapshot: ActivatedRouteSnapshot): boolean {
    // Polaris shell handles authentication - bypass guard in MFE mode
    if (this.hostContext.isPolaris) return true;
    if (environment.local) return true;
    else return this.queryParamService.getFromSnapshot(snapshot, 'mock') === 'true';
  }

  getEnv(): boolean {
    return environment.local;
  }
  // todo fix interpolate
  getRedirectUrl(): string {
    let externalWlgnUrl = `https://${this.configService.select('env.host')}${this.configService.select('external.wlgn.url')}`;
    this.localService.interpolate(externalWlgnUrl).then((value) => {
      externalWlgnUrl = value;
    });
    return externalWlgnUrl;
  }
}
